<template>
     <v-container fluid fill-height>
         <v-layout v-if="loading" align-center justify-center>
            <v-progress-circular indeterminate></v-progress-circular>
        </v-layout>
        <v-layout v-else>
            <v-flex>
                <v-card>
                    <v-layout pa-2>
                       <spray-management :masterData="masterData"> </spray-management>
                    </v-layout>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
 
import SprayManagement from '@/components/spray/SprayManagement.vue'
export default {
    data() {
        return {
            loading: false
        }
    },
    computed: {
        masterData(){
           return this.$store.getters["SprayStore/getMasterData"];
        }
    },
    methods: {

    },
    async created() {
        this.loading = true; 
        await this.$store.dispatch("SprayStore/syncUnsyncedData");          
        this.loading = false;
    },
    components: {
        SprayManagement: SprayManagement
    }
}
</script>

<style>

</style>
